import { WebApiActionGet, WebApiActionPut } from "components/ajax/WebApi";
import rootUrl from "./url";

const baseUrl = rootUrl + "api/uicontext";


export interface UIContextQuery {
    data: { [key: string]: any };
}

export interface UIContext {
    data: { [key: string]: any };
}


export const apiGetContext = function (): WebApiActionGet<UIContext> {
    return new WebApiActionGet<UIContext>(baseUrl);
}

export const apiPutContext = function (): WebApiActionPut<UIContextQuery, UIContext> {
    return new WebApiActionPut<UIContextQuery, UIContext>(baseUrl);
}

